/*@flow*/
import * as I from 'immutable';
export default (a: any, b: any): boolean => I.is(I.fromJS(a), I.fromJS(b));
